import type { Tour } from '../tour-types';

/**
 * Settings, Account: your own sign-in and email preferences. The tabs are local state and
 * the screen opens on Passkeys, so the passkeys step points at the tab it opens on; on
 * another tab it drops out.
 */
export const settingsAccountTour: Tour = {
  key: 'settings.account',
  version: 2,
  routes: ['/settings/account'],
  steps: [
    {
      anchor: 'settings-account-identity',
      placement: 'bottom',
      title: 'Your account',
      body: 'The person you are signed in as, and your role, which decides what you can change. The picker in the header switches organizations, not this.',
    },
    {
      anchor: 'settings-account-photo',
      placement: 'bottom',
      title: 'Your photo',
      body: 'Upload a photo and it replaces your initials wherever your team sees your name. It is cropped to a square and resized before it is saved.',
      since: 2,
    },
    {
      anchor: 'settings-account-badge',
      placement: 'bottom',
      title: 'Badge colour',
      body: 'The colour of your initials wherever your team sees your name, from the header to the activity log. Automatic keeps the one you were given; a photo replaces it.',
    },
    {
      anchor: 'settings-account-tabs',
      placement: 'bottom',
      title: 'Sign-in and emails',
      body: 'Passkeys and Password control how you sign in. Notifications chooses which emails reach your inbox; everything still shows under the bell.',
    },
    {
      anchor: 'settings-account-passkeys',
      title: 'Passkeys',
      body: 'Register a passkey to sign in with your device instead of typing your password. Test Passkey Authentication checks that it works.',
    },
  ],
};
